import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const windows = [{
  icon: '⚡',
  num: 1,
  time: 'Al despertar (7 min)',
  desc: 'El interruptor mental del día'
}, {
  icon: '✍️',
  num: 2,
  time: 'Mañana (10 min)',
  desc: 'El guion de tu nueva realidad'
}, {
  icon: '🌀',
  num: 3,
  time: 'Mediodía (3 min)',
  desc: 'El desapego que libera el resultado'
}, {
  icon: '🔴',
  num: 4,
  time: 'Tarde (10 min)',
  desc: 'El cuerpo como imán de atracción'
}, {
  icon: '🌙',
  num: 5,
  time: 'Pre-sueño (5 min)',
  desc: 'El subconsciente programado 8 horas'
}];
export function MechanismSection() {
  return <SectionWrapper bgColor="bg-brand-black" className="relative" data-id="element-152">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.03),transparent_70%)] pointer-events-none" data-id="element-153" />

      <div className="relative" data-id="element-154">
        <p className="text-brand-muted text-center text-base md:text-lg font-body" data-id="element-155">
          Lo que cambia todo:
        </p>

        <h2 className="font-heading text-2xl md:text-4xl lg:text-[2.8rem] text-brand-gold text-center font-bold mt-4 leading-tight" data-id="element-156">
          La "Micro-Reprogramación de 24 Horas"
        </h2>

        <div className="mt-8 space-y-4 text-brand-muted text-base md:text-lg leading-relaxed text-center max-w-2xl mx-auto font-body" data-id="element-157">
          <p data-id="element-158">No es meditación de una hora.</p>
          <p data-id="element-159">No es visualización que abandonás en 4 días.</p>
          <p data-id="element-160">No es afirmaciones que repetís sin sentir nada.</p>
          <p data-id="element-161">
            <strong className="text-brand-ivory" data-id="element-162">
              Es un sistema que opera en 5 ventanas específicas del día
            </strong>{' '}
            — cada una diseñada para un nivel diferente de tu mente, cuerpo y
            subconsciente.
          </p>
        </div>

        <div className="mt-12 space-y-4 max-w-2xl mx-auto" data-id="element-163">
          {windows.map(w => <div key={w.num} className="flex items-start gap-4 p-4 md:p-5 rounded-lg border border-brand-gold/10 bg-brand-gold/[0.03]" data-id="element-164">
              <span className="text-2xl shrink-0 mt-0.5" data-id="element-165">{w.icon}</span>
              <div data-id="element-166">
                <p className="text-brand-gold font-semibold font-body text-sm uppercase tracking-wider" data-id="element-167">
                  Ventana {w.num}
                </p>
                <p className="text-brand-ivory font-body text-base md:text-lg mt-1" data-id="element-168">
                  {w.time}
                </p>
                <p className="text-brand-muted font-body text-sm md:text-base mt-0.5" data-id="element-169">
                  {w.desc}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-brand-gold font-heading text-xl md:text-2xl text-center font-semibold mt-10" data-id="element-170">
          Total: 35 minutos al día. Las 24 horas trabajando para vos.
        </p>
      </div>
    </SectionWrapper>;
}